// extracted by mini-css-extract-plugin
module.exports = {"option":"ServiceOptions_option__iLkEZ","title":"ServiceOptions_title__1gOC3","discription":"ServiceOptions_discription__gvQdd"};